import React from 'react';

import './GuessList.css';

const capitalizeName = (string) => {
  let arr = string.split(" ")
  arr = arr.map(el => `${el[0].toUpperCase()}${el.slice(1)}`)
  return arr.join(" ")
}

const Guess = ({ label, value }) => {
  return (
    <div className={`guess-container ${value}`}>
      {capitalizeName(label)}
    </div>
  );
};

const GuessList = ({ li, target }) => {
  const renderListElements = (listEls) => {
    return listEls.map((guess) => {
      let value = "wrong";
      if (guess === target.champion) {
        value = "correct";
      }
      return <Guess key={guess} label={guess} value={value} />
    });
  };

  return (
    <div className="guess-list-container">
      {renderListElements(li)}
    </div>
  );
};

export default GuessList;
